import type { InquiryCategory, InquiryStatus } from './inquiry.type.ts';

/**
 * API 계약 주의:
 * - category/status 값은 백엔드 enum과 반드시 일치해야 한다.
 * - 백엔드 enum 변경 시 inquiry.type.ts와 모든 옵션·라벨·스타일 맵을 함께 수정한다.
 */

/** 분류 탭/셀렉트 옵션 */
export const INQUIRY_CATEGORIES: readonly {
  value: InquiryCategory;
  label: string;
}[] = [
  { value: 'GENERAL', label: '일반문의' },
  { value: 'SUGGESTION', label: '건의' },
  { value: 'ERROR', label: '오류' },
  { value: 'BUG', label: '버그' },
  { value: 'TECH', label: '기술문의' },
  { value: 'ETC', label: '기타문의' },
];

export const INQUIRY_CATEGORY_LABEL: Record<InquiryCategory, string> = {
  GENERAL: '일반문의',
  SUGGESTION: '건의',
  ERROR: '오류',
  BUG: '버그',
  TECH: '기술문의',
  ETC: '기타문의',
};

export const INQUIRY_STATUS_LABEL: Record<InquiryStatus, string> = {
  PENDING: '대기',
  ANSWERED: '답변완료',
};

/** 상태 뱃지 색상 클래스 */
export const INQUIRY_STATUS_CLASS: Record<InquiryStatus, string> = {
  PENDING: 'bg-amber-500/10 text-amber-600',
  ANSWERED: 'bg-emerald-500/10 text-emerald-600',
};

export const INQUIRY_PAGE_SIZE = 10;
